import { Navigate } from "react-router-dom";
import NotificationOutlet from "./notification-outlet";
import MessageTemplates from "./pages/message-templates";
import SmsGateways from "./pages/sms-gateways";
import SmsCharges from "./pages/sms-charges";
import Providers from "./pages/providers";

const NotificationRoutes = [
  {
    path: "/notifications",
    element: <NotificationOutlet />,
    children: [
      { index: true, element: <Navigate to="providers" replace /> },
      { path: "providers", element: <Providers /> },
      { path: "templates", element: <MessageTemplates /> },
      { path: "sms-gateways", element: <SmsGateways /> },
      { path: "sms-charges", element: <SmsCharges /> },
    ],
  },
];

export default NotificationRoutes;